import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TeacherSidebarDetail = (props) => {
    const { t, i18n } = useTranslation()
    // Menü başlıkları (öğretmenler, sınıflar, öğrenciler...) varsayılan olarak açık gelir.
    const [open, setOpen] = useState({ class: true, student: true });
    const toggleSection = (id) => {
        setOpen((prev) => ({ ...prev, [id]: !prev[id] }));
    };
    const { user } = useAuth();
    return (
        <ul class="list-unstyled components">

            <li id="classesteacher">
                <div>
                    <a href="#" className="dropdown-toggle" aria-controls="class" aria-expanded={!!open.class} onClick={(e) => { e.preventDefault(); toggleSection("class"); }}>
                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>
                        <b className="forsidebar">
                            &nbsp;
                            {t("classes")}
                        </b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.class ? "show" : ""}`} id="class">
                        <li>
                            <a href="/school/classlist">
                                <b><FontAwesomeIcon icon="fas fa-user-friends" /></b>
                                <b className="forsidebar">
                                    {t("classlist")}
                                </b>
                            </a>
                        </li>

                        <li>
                            <a href="/school/createclass">
                                <b>
                                    <FontAwesomeIcon icon="fas fa-user" />
                                </b>
                                <b className="forsidebar">
                                    {t("createclass")}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <br />
            <li id="studentsteacher">
                <div>
                    <a href="#" className="dropdown-toggle" aria-controls="student" aria-expanded={!!open.student} onClick={(e) => { e.preventDefault(); toggleSection("student"); }}>
                        <b>
                            <FontAwesomeIcon icon="fas fa-users" />
                        </b>
                        <b className="forsidebar">
                            &nbsp;
                            {t("students")}
                        </b>
                    </a>
                    <ul className={`collapse list-unstyled ${open.student ? "show" : ""}`} id="student">
                        <li>
                            <a href="/school/studentcreate">
                                <b className="forsidebar">
                                    {t("createstudent")}
                                </b>
                            </a>
                        </li>
                        <li>
                            <a href="/school/studentlist">
                                <b className="forsidebar">
                                    {t("studentList")}
                                </b>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>

        </ul>
    );
};

export default TeacherSidebarDetail;